import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { AlertController, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { BookingModel } from "src/app/_models/booking.model";
import { User } from "src/app/_models/user.model";
import { UserService } from "src/app/_services";
import { BookingService } from "src/app/_services/booking.service";
import { ThisPlatform } from "src/app/_services/platform.service";
import { SpaceType } from "src/app/_types/space-type";

@Component({
  selector: "app-space-booking-view-change-user",
  templateUrl: "./space-booking-view-change-user.component.html",
  styleUrls: ["./space-booking-view-change-user.component.scss"],
})
export class SpaceBookingViewChangeUserComponent implements OnInit {
  idUser: number;
  comment: string;
  form: FormGroup;
  booking: BookingModel;
  carPlate: string;
  selectedUser: User;

  @Input()
  assignmentDetails;

  @Input()
  spaceType: SpaceType;

  spaceHader: string;

  constructor(
    private modalCtrl: ModalController,
    public translateServ: TranslateService,
    public userService: UserService,
    private bookingServ: BookingService,
    public p: ThisPlatform,
    private alertController: AlertController,
  ) {}

  ngOnInit() {
    this.setTranslationForSpaceType(this.spaceType)
    this.booking = this.bookingServ.booking;
  }

  setUser(event) {
    this.idUser = event.id;
    this.selectedUser = event;
  }

  save() {
    this.booking.idUserOwner = this.idUser;
    this.booking.userOwner =  this.selectedUser;
    this.booking.startTime = this.assignmentDetails.startTime;
    this.booking.endTime = this.assignmentDetails.endTime;
    this.bookingServ.booking = this.booking

    this.bookingServ.updateBooking(this.booking).subscribe(() => {
      this.modalCtrl.dismiss("update");
    },
    (err) => {
      this.handleError(err);
    });
  }

  back() {
    this.modalCtrl.dismiss();
  }

  /**
   * Metoda obsługująca bad request
   * @param errorCode Kod błędu. Występuje w (error) =>{error.error.code;}
   */
   async handleError(error) {
    let errorMessage: string = "";
    switch (error.error.code) {
      case 1: {
        errorMessage = this.translateServ.instant("SPACE.ERROR.ERROR_1");
        break;
      }
      case 2: {
        errorMessage = this.translateServ.instant("SPACE.ERROR.ERROR_2");
        break;
      }
      case 3: {
        errorMessage = this.translateServ.instant("SPACE.ERROR.ERROR_3");
        break;
      }
      default: {
        if (error.status === 403) {
          errorMessage = this.translateServ.instant(
            "SPACE.ERROR.ERROR_STATUS_403"
          );
        } else {
          errorMessage = this.translateServ.instant(
            "SPACE.ERROR.BARRIER_ERROR"
          );
        }
      }
    }
    const alert = await this.alertController.create({
      header: this.translateServ.instant("SPACE.ERROR.ERROR"),
      message: errorMessage,
      buttons: ["OK"],
    });
    await alert.present();
  }

  setTranslationForSpaceType(spaceType: SpaceType) {
    switch(spaceType){
      case SpaceType.Desk: {
        this.spaceHader = this.translateServ.instant("SPACE.DESK.CHANGE_USER");
        break;
      }
      case SpaceType.Parking: {
        this.spaceHader = this.translateServ.instant("SPACE.PARKING.CHANGE_USER");
        break;
      }
      case SpaceType.Room: {
        this.spaceHader = this.translateServ.instant("SPACE.ROOM.CHANGE_USER");
        break;
      }
    }

  }

}
